var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp3FileTypeSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101010;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xxx-word"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,105H250a5,5,0,0,1-5-5V25a5,5,0,0,1,10,0V95h70a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,280H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,330H125a5,5,0,0,1,0-10h75a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.71,236h-9.8V189.32L154.14,236h-5l-14.84-46.68V236h-7.85V182.68h15L152.62,217l11-34.34h15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.08,236h-9.61V182.68H212.3q9.34,0,13.85,4.71a16.37,16.37,0,0,1-.37,22.95,17.49,17.49,0,0,1-12.38,4.53H200.08Zm0-29.37h11.37q4.45,0,6.8-2.19a7.58,7.58,0,0,0,2.34-5.82,8,8,0,0,0-2.17-5.62q-2.17-2.34-7.83-2.34H200.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.37,212.45v-7.58h4.88a12.88,12.88,0,0,0,7.3-2,6.53,6.53,0,0,0,2.93-5.82,6.76,6.76,0,0,0-2.48-5.7,10.16,10.16,0,0,0-6.39-1.91q-7.89,0-10.74,7.73l-8.79-1.52a16.93,16.93,0,0,1,6.86-10,21.57,21.57,0,0,1,12.95-3.87,21.26,21.26,0,0,1,12.87,3.89,12.24,12.24,0,0,1,5.33,10.41,12.49,12.49,0,0,1-2.87,8.28,9.9,9.9,0,0,1-7.09,3.75,13.59,13.59,0,0,1,8.42,4.34,12.38,12.38,0,0,1,3.18,8.55,13.87,13.87,0,0,1-5.53,11.31q-5.53,4.43-14.71,4.43-8.48,0-14-4.32a18.47,18.47,0,0,1-7-9.9l9.1-2.23q2.73,8.91,11.8,8.91a11.39,11.39,0,0,0,7.56-2.4,7.32,7.32,0,0,0,2.87-5.8,8.47,8.47,0,0,0-2.48-6q-2.48-2.6-7.48-2.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3FileTypeSvgrepoCom);
export default __webpack_public_path__ + "static/media/mp3-file-type-svgrepo-com.def2e9ae5d62bdae7d2f3dc16c7ee765.svg";
export { ForwardRef as ReactComponent };